// hooks/useGetPersonalInfo.js
import { useCallback, useEffect, useState } from 'react';
import { fetchPersonalInfo } from '../data/fetchPersonalInfo';
import { useNotify } from '../context/NotificationContext';

const useGetPersonalInfo = (token) => {
  const [data, setData] = useState(null); // { settings, types }
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const payload = await fetchPersonalInfo(token);
      setData(payload);
    } catch (e) {
      console.error('useGetPersonalInfo:', e);
      setError(e);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    if (token) load();
  }, [token, load]);

  return { data, loading, error, refetch: load };
};

export default useGetPersonalInfo;
